import { render, staticRenderFns } from "./m-chambre.html?vue&type=template&id=b5c8e6fa&scoped=true&external"
import script from "./m-chambre.js?vue&type=script&lang=js&external"
export * from "./m-chambre.js?vue&type=script&lang=js&external"
import style0 from "./m-chambre.scss?vue&type=style&index=0&id=b5c8e6fa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c8e6fa",
  null
  
)

export default component.exports